module.exports = __webpack_public_path__ + "static/media/conn_point_cf_comparative_per_month.c162baf7.svg";